"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setValueInResults = exports.isEmpty = exports.setErrorUnFormWithYup = exports.deleteEmpty = exports.CreateRange = exports.OnlyNumbers = exports.NumberFormat = exports.objectExcept = void 0;
var collect_js_1 = require("collect.js");
var Yup = __importStar(require("yup"));
function objectExcept(object, excepts) {
    return collect_js_1.collect(object).sortKeys().except(excepts).all();
}
exports.objectExcept = objectExcept;
function NumberFormat(number, decimals, decPoint, thousandsSep) {
    if (decimals === void 0) { decimals = 2; }
    if (decPoint === void 0) { decPoint = ','; }
    if (thousandsSep === void 0) { thousandsSep = '.'; }
    number = ("" + number).replace(/[^0-9+\-Ee.]/g, '');
    var n = !Number.isFinite(+number) ? 0 : +number;
    var prec = !Number.isFinite(+decimals) ? 2 : Math.abs(decimals);
    var sep = typeof thousandsSep === 'undefined' ? '.' : thousandsSep;
    var dec = typeof decPoint === 'undefined' ? ',' : decPoint;
    var toFixedFix = function (_n, _prec) {
        var k = Math.pow(10, _prec);
        return "" + (Math.round(_n * k) / k).toFixed(_prec);
    };
    var s = (prec ? toFixedFix(n, prec) : "" + Math.round(n)).split('.');
    if (s[0].length > 3) {
        s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
    }
    if ((s[1] || '').length < prec) {
        s[1] = s[1] || '';
        s[1] += new Array(prec - s[1].length + 1).join('0');
    }
    return s.join(dec);
}
exports.NumberFormat = NumberFormat;
function OnlyNumbers(string) {
    if (!string) {
        return '';
    }
    string = string.toString();
    return string.replace(/[^0-9]/g, '');
}
exports.OnlyNumbers = OnlyNumbers;
function CreateRange(end, start) {
    if (start === void 0) { start = 0; }
    var array = [];
    for (var i = start; i < end; i += 1) {
        array.push(i);
    }
    return array;
}
exports.CreateRange = CreateRange;
function deleteEmpty(object) {
    var newObject = __assign({}, object);
    return Object.fromEntries(Object.entries(newObject)
        .filter(function (_a) {
        var key = _a[0], value = _a[1];
        return value !== '' &&
            value !== undefined &&
            value !== null &&
            (value instanceof Array ? value.length !== 0 : true);
    })
        .map(function (_a) {
        var key = _a[0], value = _a[1];
        return [key, value];
    }));
}
exports.deleteEmpty = deleteEmpty;
function setErrorUnFormWithYup(formRef, data, schema) {
    return __awaiter(this, void 0, void 0, function () {
        var err_1, validationErrors_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    formRef.current.setErrors({});
                    return [4, schema.validate(data, {
                            abortEarly: false,
                        })];
                case 1:
                    _a.sent();
                    return [3, 3];
                case 2:
                    err_1 = _a.sent();
                    validationErrors_1 = {};
                    if (err_1 instanceof Yup.ValidationError) {
                        err_1.inner.forEach(function (yupError) {
                            validationErrors_1[yupError.path] = yupError.message;
                        });
                        formRef.current.setErrors(validationErrors_1);
                    }
                    else {
                    }
                    return [2, false];
                case 3: return [2, true];
            }
        });
    });
}
exports.setErrorUnFormWithYup = setErrorUnFormWithYup;
function isEmpty(mixedVar) {
    var undef;
    var key;
    var i;
    var len;
    var emptyValues = [undef, null, false, 0, '', '0'];
    for (i = 0, len = emptyValues.length; i < len; i += 1) {
        if (mixedVar === emptyValues[i]) {
            return true;
        }
    }
    if (typeof mixedVar === 'object') {
        for (key in mixedVar) {
            if (mixedVar.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }
    return false;
}
exports.isEmpty = isEmpty;
function setValueInResults(array, key, value, putValue) {
    return array.map(function (el) {
        if (el[key] === value) {
            el = __assign(__assign({}, el), putValue);
        }
        return el;
    });
}
exports.setValueInResults = setValueInResults;
//# sourceMappingURL=utils.service.js.map